import React from 'react';
import { BasePlanCard, PlanCardProps } from './BasePlanCard';

const PRO_ADVANCED_PRICE_USD = 12900;

export const AdvancedPlan = (props: PlanCardProps) => (
    <BasePlanCard planType="advanced" advancedPlanPrice={PRO_ADVANCED_PRICE_USD} {...props} />
);
